import React from "react";
import ModalEdit from "./ModalEdit";
import styles from "./person.module.css";
import { format } from "date-fns";

const PersonData = ({ profileData, handleUpdateProfileData, isEditable }) => {
  return (
    <section>
      <div className={styles.main}>
        <div className={styles.personDataLeft}>
          <h3>Personal Data</h3>
          {profileData.first_name && profileData.last_name && (
            <p className={styles.fullName}>
              Name:{" "}
              <span>
                {profileData.first_name} {profileData.last_name}
              </span>
            </p>
          )}
          {profileData.city &&
            typeof profileData.city === "string" &&
            profileData.city.trim() !== "" && (
              <>
                <p>
                  {" "}
                  <span>Username: {profileData.username}</span>
                </p>
                <p>
                  <span>City: {profileData.city}</span>
                </p>
              </>
            )}
          {profileData.country &&
            typeof profileData.country === "string" &&
            profileData.country.trim() !== "" && (
              <>
                <p>
                  <span>Country: {profileData.country}</span>
                </p>
              </>
            )}
          {profileData.birthdate && (
            <p>
              <span>
                Date of Birth:{" "}
                {profileData.birthdate
                  ? format(new Date(profileData.birthdate), "dd/MM/yyyy")
                  : ""}
              </span>
            </p>
          )}
          {profileData.birth_country && (
            <p>
              <span>Birth Country: {profileData.birth_country}</span>
            </p>
          )}
          <p>
            <span>Learned Language: {profileData.learned_language}</span>
          </p>
          <p>
            <span>Native Speaker: {profileData.native_language}</span>
          </p>
          <p>
            <span>Gender: {profileData.gender}</span>
          </p>
        </div>
        <div className={styles.personDataRight}>
          {profileData.description &&
            typeof profileData.description === "string" &&
            profileData.description.trim() !== "" && (
              <>
                {" "}
                <h3>Personal Description</h3>
                <p>{profileData.description}</p>
              </>
            )}

          {profileData.education &&
            typeof profileData.education === "string" &&
            profileData.education.trim() !== "" && (
              <>
                {" "}
                <h3>Education</h3>
                <p>{profileData.education}</p>
              </>
            )}
          {profileData.hobbies &&
            typeof profileData.hobbies === "string" &&
            profileData.hobbies.trim() !== "" && (
              <>
                {" "}
                <h3>Hobbies</h3>
                <p>{profileData.hobbies}</p>
              </>
            )}
        </div>
        {isEditable && (
          <div className={styles.linkContainer}>
            <ModalEdit
              profileData={profileData}
              updateInfo={handleUpdateProfileData}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default PersonData;
